import React from 'react';
import { motion } from 'framer-motion';

export default function TimelineNavigation({ years, currentYear, onYearClick }) {
  return (
    <div className="relative">
      <div className="absolute top-1/2 left-0 right-0 h-0.5 bg-red-100 -translate-y-1/2" />
      
      <div className="relative flex justify-between items-center max-w-4xl mx-auto">
        {years.map((year) => (
          <button
            key={year}
            onClick={() => onYearClick(year)}
            className="relative group"
          >
            <motion.div
              className={`w-8 h-8 rounded-full border-4 transition-colors duration-300 
                ${currentYear === year 
                  ? 'bg-red-600 border-white' 
                  : 'bg-white border-red-200 group-hover:border-red-300'}`}
              whileHover={{ scale: 1.2 }}
              whileTap={{ scale: 0.9 }}
            />
            
            <span className={`absolute -bottom-8 left-1/2 -translate-x-1/2 font-bold text-sm
              ${currentYear === year ? 'text-red-600' : 'text-gray-400'}`}>
              {year}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}